import Lottie from 'react-lottie';
import clsx from 'clsx';

import loadingSpinner from '~/shared/assets/lotties/loading-spinner.json';

export default function Loader({ variant = 'lg' }: { variant?: 'sm' | 'lg' | 'xl' }) {
  const height = variant === 'sm' ? 110 : variant === 'lg' ? 180 : 264;
  const width = variant === 'sm' ? 110 : variant === 'lg' ? 180 : 264;

  return (
    <div className="flex items-center justify-center">
      <div className="flex flex-1 justify-center items-center">
        <span
          className={clsx(
            'inline-block',
            variant === 'sm' ? '-ml-10 -mr-10 ' : variant === 'lg' ? '' : ' ' // negative margin because of whitespace in lottie
          )}
        >
          <Lottie
            options={{
              loop: true,
              autoplay: true,
              animationData: loadingSpinner,
              rendererSettings: {
                preserveAspectRatio: 'xMidYMid meet',
              },
            }}
            height={height}
            width={width}
            isClickToPauseDisabled
          />
        </span>
      </div>
    </div>
  );
}
